const APIS = {
  BRANCH_INVOICE: "/invoiceservice/api/branch-invoice/",
  RIDER_INVOICE: "/invoiceservice/api/rider-invoice/",
  MERCHANT_INVOICE: "/invoiceservice/api/merchant-invoice/",
  MERCHANT_ITEM: "/invoiceservice/api/merchant-invoice-item/",
  CLIENT_SETTING: "/projectsettingsservice/api/configuration/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  MERCHANT: "/logisticservice/api/merchant/",
  ORDER: "/logisticservice/api/order/",
  DESTINATION: "logisticservice/api/location/list/",
  PERMISSION: "/permission/",
  INVOICE_ORDER: "/invoiceservice/api/order/",
  // INVOICE_REPORT: "/invoiceservice/api/branch-invoice/report/",
  BRANCH_ORDER: "/manifestservice/api/order/",
  LOCATION: "logisticservice/api/location/",
  CUSTOMER: "logisticservice/api/customer/",
  RIDER_ORDERS: "/runsheetservice/api/runsheet-item/",
  STATUS: "/invoiceservice/api/invoice-status/",
  RIDER: "/fleetservice/api/driver/",
  BRANCH: "logisticservice/api/branch/",
  USER_PROFILE: "logisticservice/api/user-profile/",
  PAYMENT_METHOD_TYPE: "logisticservice/api/payment-method/",
  INVOICE_TYPE: "/invoiceservice/api/invoice-types/",
  CONFIRM: "invoiceservice/api/order/orders-detail/",
  WAREHOUSE: "logisticservice/api/warehouse/",
  STAFF: "usermanagementservice/api/user/",
  USER: "/usermanagementservice/api/user/",
  GRID_REPORT_DATA: "/projectsettingsservice/api/courier-grid-report/",
  PAYMENT_METHOD: "/invoiceservice/api/payment-method/",
  MAKE_PAYMENT: "/invoiceservice/api/payment-method/make-payment/",
  ORDER_STATUS: "/logisticservice/api/status/",
  USER_INFO: "usermanagementservice/api/user/me",
  MERCHANT_INVOICE_REPORT:
    "/logisticservice/api/merchant/merchant-wise-report/",
  SHIP_VIA: "/logisticservice/api/ship-via/",
  REMOTE_CHAGRE: "/logisticservice/api/remote-charge/",
  SERVICE_TYPE: "logisticservice/api/service-type/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  REFERENCE_TYPE: "logisticservice/api/reference-type/",
};

export default APIS;
